// extracted by mini-css-extract-plugin
export default {"special":"SpecialPage_special__gIZVX","date":"SpecialPage_date__33+bT","submissionDiv":"SpecialPage_submissionDiv__KNAGb","error":"SpecialPage_error__fmuLt"};